import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import ReportService from "../../../services/report-service/ReportService";
import Utili from "../../../utility/Utility";
import SpinnerLoader from "../../../components/spinner-loader/SpinnerLoader.component";
import { TextField } from "@material-ui/core";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

const getInitialDate = (days: number) => {
  var newDt = new Date();
  newDt.setDate(newDt.getDate() + days);
  return moment(newDt).format("YYYY-MM-DD");
};

function ReferralReport(props: any) {

  const [selectedToDate, setSelectedToDate] = React.useState(getInitialDate(0));
  const [selectedFromDate, setSelectedFromDate] = React.useState(
    getInitialDate(-30)
  );
  const classes = useStyles();
  const [maxDate, setMaxToDate] = React.useState(getInitialDate(0));
  const [reportData, setReportData] = useState("");
  const [pdfBytes, setpdfBytes] = useState("");

  const [fullName, setFullName] = React.useState("");

  const handleFullNameChange = (name: any) => {
    console.log("name=" + name.target.value);
    setFullName(name.target.value);
  };


  const getReferral = () => {

    console.log("fullName=" + fullName);
    ReportService.getReferralReport(fullName == "" ? "" : fullName,selectedFromDate, selectedToDate).then(
      (res: any) => {
        setReportData(res.data.result.reportHTML);
        setpdfBytes(res.data.result.reportBytes);
        setShowDownloadBtn(true);
      }
    );
  };
  const ClearSearchCriteria = () => {
    setFullName("");
  };
  const Download = () => {
    var blob = Utili.b64toBlob(pdfBytes);
    var url = URL.createObjectURL(blob);
    let a = document.createElement("a");
    a.href = url;
    a.download = "ReferralReport";
    a.click();
  };
  const handleFromDateChange = (date: any) => {
    console.log(date.target.value);
    setSelectedFromDate(date.target.value);
  };
  const handleToDateChange = (date: any) => {
    setSelectedToDate(date.target.value);
  };
  const [showDownloadBtn, setShowDownloadBtn] = useState(false);
  return (
    <div className="col-12">
       <SpinnerLoader isGeneral={true} tasksList={
        ['GetReferralReport']
      } inInternal={false} />
      <h3>Referrals</h3>
      <div className="pt-2">
        <div className="formouter">
          <form className={classes.container} noValidate>
           
<TextField
            id="txtFullName"
            label="Name"
            type="text"
            value={fullName}
            onChange={handleFullNameChange}
            InputProps={{ inputProps: { max: selectedToDate } }}
            defaultValue="0001-01-01" // 0001-01-01
            className={classes.textField}
      
            InputLabelProps={{
              shrink: true,
            }}
          />

<TextField
            id="dateFrom"
            label="From Date"
            type="date"
            value={selectedFromDate}
            onChange={handleFromDateChange}
            InputProps={{ inputProps: { max: selectedToDate } }}
            defaultValue="0001-01-01" // 0001-01-01
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
          />
 
 <TextField
            id="dateTo"
            label="To Date"
            type="date"
            value={selectedToDate}
            onChange={handleToDateChange}
            InputProps={{ inputProps: { max: maxDate } }}
            //defaultValue="0001-01-01"
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
          />
            <button
              color="secondary"
              onClick={ClearSearchCriteria}
              type="button"
              className="btn btn-sm  float-right search-btn stnd-btn view-r-btn"
            >
              Reset
            </button>
            <button
              color="secondary"
              onClick={getReferral}
              type="button"
              className="btn btn-sm  float-right search-btn stnd-btn view-r-btn"
            >
              View Report
            </button>
          </form>
        </div>
        <div className="mt-4">
          <div className="mb-0 heading">
            <h5>
              Report{" "}
              {showDownloadBtn ? (
                <button
                  color="secondary"
                  onClick={Download}
                  type="button"
                  className="btn btn-sm btn-outline-secondary float-right"
                >
                  Save as
                </button>
              ) : (
                ""
              )}
            </h5>
          </div>
          <div className="report-view-bx">
            <div dangerouslySetInnerHTML={{ __html: reportData }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReferralReport;
